import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { urls } from "../configs/serviceConfig";
import { authorizationHeaders } from "./authorizationHeaders";
import {
  EngagementCategory,
  EngagementType,
} from "../enums/engagementApiTypes";
import dayjs from "dayjs";

interface EngagementPostRequest {
  userId: string;
  sessionId: string;
}

export const engagementsApi = createApi({
  reducerPath: "engagementsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.engagementService}`,
    prepareHeaders: authorizationHeaders,
  }),

  endpoints: (builder) => ({
    logRefreshAccessToken: builder.mutation<string, EngagementPostRequest>({
      query(data) {
        return {
          url: `/api/engagements`,
          method: "POST",
          body: {
            category: EngagementCategory.Session,
            type: EngagementType.Refresh,
              timestamp: dayjs().toISOString(),
            data: data,
          },
        };
      },
    }),
    logSignOut: builder.mutation<string, EngagementPostRequest>({
      query(data) {
        return {
          url: `/api/engagements`,
          method: "POST",
          body: {
            category: EngagementCategory.Session,
            type: EngagementType.Logout,
              timestamp: dayjs().toISOString(),
            data: data,
          },
        };
      },
    }),
    logSignIn: builder.mutation<string, EngagementPostRequest>({
      query(data) {
        return {
          url: `/api/engagements`,
          method: "POST",
          body: {
            category: EngagementCategory.Session,
            type: EngagementType.Login,
              timestamp: dayjs().toISOString(),
            data: data,
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLogSignInMutation,
  useLogSignOutMutation,
  useLogRefreshAccessTokenMutation,
} = engagementsApi;
